<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/moneyBack_list',title:'回款管理'},{title:'回款认领（外）'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox width">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="导入序号/ID">
                                <el-input v-model="formInline.inId" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="汇款人名称">
                                <el-input v-model="formInline.remitterName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经销商姓名">
                                <el-input v-model="formInline.customerName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经销商编码">
                                <el-input v-model="formInline.customerCode" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="销售组织" prop="saleGroupCode">
                                <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true"
                                          v-model="formInline.saleGroupCode" clearable></brselect>
                            </el-form-item>

                            <el-form-item label="凭证编号">
                                <el-input v-model="formInline.receCertNumber" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="认领状态">
                                <brselectlazy category="claimed_type" :v="formInline.isClaimeds"
                                              v-model="formInline.isClaimeds"  :clearable="true"/>
                            </el-form-item>
                            <el-form-item label="文本">
                                <el-input v-model="formInline.text" placeholder="请输入"></el-input>
                            </el-form-item>

                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="回款时间" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.startReceDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.endReceDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>

                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
							</el-button>
<!--							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"-->
<!--							           @click="addMoneyBack">新增回款-->
<!--							</el-button>-->
						</div>
					</div>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData2.records"
                        stripe
                        style="width: 100%"
						max-height="450"
						:border="true">
                    <el-table-column
                            type="selection"
                            width="40"
                            label="全选">
                    </el-table-column>

                    <el-table-column
                            prop="remitterName"
                            label="汇款人名称"
                            :show-overflow-tooltip="true"
                            min-width="200">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.remitterName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="receBank"
                            label="汇款银行"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receDate"
                            label="回款时间"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receCurrency"
                            label="币种"
                            :show-overflow-tooltip="true"
                            width="50"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receAmount"
                            label="入账金额"
                            :show-overflow-tooltip="true"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="enterAmount"
                            label="认领金额"
                            :show-overflow-tooltip="true"
                            width="80"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="saleGroupCode"
                            label="销售组织"
                            :show-overflow-tooltip="true"
                            min-width="80">
                    </el-table-column>
                    <el-table-column
                            prop="customerCode"
                            label="经销商编码"
                            :show-overflow-tooltip="true"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            prop="customerName"
                            label="经销商名称"
                            :show-overflow-tooltip="true"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            prop="isClaimed"
                            label="认领状态"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <dictname category="claimed_type" :v="scope.row.isClaimed"/>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                            prop="receMark"-->
                    <!--                            label="回款类型"-->
                    <!--                            :show-overflow-tooltip="true"-->
                    <!--                    >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <dictname category="credit_type" :v="scope.row.receMark"/>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            prop="claimDate"
                            label="认领时间"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            prop="balanceAmount"
                            label="认领余额"
                            :show-overflow-tooltip="true"
                            width="100"

                    >
                    </el-table-column>

                    <el-table-column
                            prop="wenben"
                            label="文本"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            prop="swwWenben"
                            label="文本"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column

                            prop="inId"
                            label="导入序号"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="id"
                            label="ID"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="receCertNumber"
                            label="凭证编号"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="blart"
                            label="凭证类型"
                            min-width="77"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160"
                    >
                        <template slot-scope="scope">
                           <div style="display: flex;justify-content: flex-start;align-items: center;">
                                <el-button
										style="padding: 0;"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        v-if="showLook(scope.row)"
                                        @click="detail(scope.row),look">
                                    查看
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
										style="padding: 0;"
                                        class="h-tableLink h-btn"
                                        v-if="showClaim(scope.row)"
                                        @click="taps(scope.row),go">
                                    认领
                                </el-button>
                               <el-button
                                       type="text"
                                       size="small"
                                       style="padding: 0;"
                                       class="h-tableLink h-btn"
                                       v-if="showTrim(scope.row)"
                                       @click="trim(scope.row),go">
                                   调整
                               </el-button>
                               <el-button
                                       type="text"
                                       size="small"
                                       style="padding: 0;"
                                       class="h-tableLink h-btn"
                                       v-if="showContinue(scope.row)"
                                       @click="toContinue(scope.row)">
                                   重新认领
                               </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">


                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="choose"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


    export default {
        components: {
            uploaddownexcel,
        },
        name: 'leftMenu',
        data() {
            var validatereceAmount = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入金额'));
                } else {
                    const age = /^\d+$|^\d*\.\d+$/g;
                    if (!age.test(value)) {
                        callback(new Error('金额只能为数字！'))
                    } else {
                        callback()
                    }
                }
            };
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                refid: '111',
                reftype:'回款认领-上传凭证',
                uploaddownexcelflag: false,
                value2: '',
                rules2: {
                    receBank: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    remitterName:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    receCurrency:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    // receCertNumber:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // receMark:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    receAmount:
                        [
                            {required: true, validator: validatereceAmount, trigger: 'blur'},
                        ],
                    receDate:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    checkboxGroup1:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    countryCode:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    tradeWay:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ]
                },
                page: {},
                q: {
                    // codeLikenameLike: null,
                    // categoryLikecatenameLike: null,
                    // delflag: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                //表单
                formInline: {
                    remitterName: '',
                    isClaimeds: '',
                    startReceDate: '',
                    endReceDate: '',
                    receMark: '',
                    pageSize: 10,
                    pageNo: 1
                },
                //表格
                multipleSelection: [],
                tableData2: [],

                //弹框
                dialogFormVisible: false,
                formLabelAlign2: {
                    id: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    remitterName: null,
                    receMark: '',
                    receAmount: null,
                    receCurrency: null,
                    receCertNumber: null,
                    receBank: null,
                    receDate: null,
                    isClaimed: null,
                    remark: null,
                    remitterCode: null,
                    areaCode: null,
                    countryCode: null,
                    tradeWay: null,
                    checkboxGroup1: [],
                },
                cities: ['非洲', '亚太', 'UN'],
                flag: 0,
                status: true,
            }
        },

        created() {
            this.search();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            uploadExcelFilecallback(rd) {
                console.log(rd)
                if (rd == null) {
                } else {
                    this.$msg.alert(rd.msg);
                    this.query();
                }

            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            inputExeal() {
                // ss.moneyBackforeignService.
            },
            timeSelect() {
                this.formInline.startReceDate = this.value2[0];
                this.formInline.endReceDate = this.value2[1];
            },
            download() {
                //ids
                var cc = [];

                for (var d in this.tableData2.records.id) {

                    cc.push(this.tableData2.records[d].id);

                }

                //查询参数
                var c = {

                    ids: cc,

                };

                ss.moneyBackforeignService.download(c);
            },

            //是否显示查看按钮
            showLook(v) {
                if (v.isClaimed === 3) {
                    return false;
                } else {
                    return true;
                }
            },
            // 独立的总部判断逻辑
            isHeadquarters(saleGroupCode) {
                const headquartersCodes = ['1RK0', '6200', '9370', '9390'];
                return headquartersCodes.includes(saleGroupCode);
            },

            //是否显示认领按钮
            showClaim(v) {
                if(this.isHeadquarters(v.saleGroupCode)) {
                    return false;
                }else if (v.isClaimed === 2 || v.isClaimed === 3 || v.isClaimed === 4 || v.isClaimed === 5 || v.isClaimed === 6 || v.isClaimed === 7 || v.isClaimed === 8) {
                    return false;
                } else {
                    return true;
                }
            },
            //是否显示调整按钮
            showTrim(v) {
                if(this.isHeadquarters(v.saleGroupCode)) {
                    return false;

                }else if ( (v.isClaimed === 1 || v.isClaimed === 2 ) && v.isClear === 1) {
                    return true;
                } else {
                    return false;
                }
            },
            //是否显示继续编辑按钮
            showContinue(v) {
                if(this.isHeadquarters(v.saleGroupCode)) {
                    return false;
                }else if (v.isClaimed === 5) {
                    return true;
                }else {
                    return false;
                }
            },
            //是否显示绑定订单按钮
            showBandOrders(v) {
                if (v.isClaimed === 6) {
                    return true;
                } else {
                    return false;
                }
            },
            choose() {
                if (this.flag === 1) {
                    this.search();
                } else {
                    this.query();
                }
            },
            searchReset() {
                this.q.pageNo = 1;
                this.search();
            },
            //根据条件检索
            search() {
                this.formInline.pageNo = this.q.pageNo;
                this.formInline.pageSize = this.q.pageSize;
                ss.moneyBackforeignService.conditionalUserSearch(this.formInline).then(response => {
                    console.log(response)
                    this.q.total = response.total;
                    // console.log(rd);
                    this.tableData2 = response;
                    this.flag = 1;

                })
            },
            //重置检索项
            resetData() {
                this.value2 = '';
                this.formInline.remitterName = '';
                this.formInline.isClaimeds = '';
                this.formInline.startReceDate = '';
                this.formInline.endReceDate = '';
                this.formInline.receMark = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.flag = 0;
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;
                this.query();
            },
            go() {
                let v = {backurl:"moneyClaim_list"}
                this.$router.push({path: '/moneyBack_claim', query: v})
            },
            taps(v) {
                if (v.isClaimed === 2) {
                    this.$message({
                        type: "warning",
                        message: '该回款已被认领，无法重复认领！'
                    });
                } else {
                    v.backurl = "moneyClaim_list";
                    this.$router.push({path: "/moneyBack_claim", query: v});
                }
            },
            trim(v) {
                if (v.isClear=== 2) {
                    this.$message({
                        type: "warning",
                        message: '该回款已被清账，无法调整！'
                    });
                } else {
                    v.backurl = "moneyClaim_list";
                    this.$router.push({path: "/moneyBack_trim", query: v});
                }
            },
            //继续编辑
            toContinue(v) {
//                 v.backurl = "moneyBack_list";
                this.$router.push({
                    path: "/moneyBack_claim",
                    query: { ywid: v.id, instid: v.instid, backurl:"moneyBack_list"}
                })
                // this.$router.push({path: '/moneyBack_claim', query: v})

            },
            look() {
                let v = {backurl:"moneyClaim_list"}
                this.$router.push({path: '/moneyBack_detail', query: v})
            },
            detail(v) {
                v.backurl = "moneyClaim_list";
                this.$router.push({path: "/moneyBack_detail", query: v});
                console.log(v, "aaaaaaaaaaaa")
            },
            // 查询外回款分页列表
            query() {
                ss.moneyBackforeignService.query(this.q).then(rd => {
                    this.q.total = rd.total;
                    console.log(rd);
                    this.tableData2 = rd;
                })
            },
            //每次点击新增回款时重置表单和校验结果
            addMoneyBack() {
                this.dialogFormVisible = true;
                console.log(this.status, 'aaaaaaaaaa')
                if (this.status) {
                    this.$nextTick(() => {
                        this.$refs["formLabelAlign2"].resetFields();
                    });
                }

            },
            //新增回款
            insert(form) {
                console.log(this.formLabelAlign2);
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.formLabelAlign2.areaCode = this.formLabelAlign2.checkboxGroup1.toString();
                        this.formLabelAlign2.receMark = 1;
                        ss.moneyBackforeignService.insert(this.formLabelAlign2).then(response => {
                            console.log(response);
                            if (response.f) {
                                this.dialogFormVisible = false;
                                this.query();
                                this.$message({
                                    type: "success",
                                    message: response.msg
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });
                this.status = true;
            },
            //暂存草稿
            rough() {
                // this.status = false;
                this.formLabelAlign2.areaCode = this.formLabelAlign2.checkboxGroup1.toString();
                ss.moneyBackforeignService.insertRough(this.formLabelAlign2).then(response => {
                    if (response.f) {
                        this.dialogFormVisible = false;
                        this.query();
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }
                })
            },
            //取消新增
            cancel() {
                this.dialogFormVisible = false;
                this.status = true;
                this.$message({
                    type: "warning",
                    message: '已取消新增'
                });
            },

            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        }
    }
</script>

<style>
	.dialogForms .h-elformWrap-2 {
	    width: 50%!important;
	}
    .dialogForms .h-elformWrap-2 .el-form-item__label {
        width: 50%;
    }

    .dialogForms .h-elformWrap-2 .el-form-item__content {
        width: 50%;
    }

    .width .el-date-editor .el-range-separator {
        width: 9%;
		line-height: 0.35rem;
    }

    .width .el-date-editor .el-range-input {
        width: 55%;
    }

    .width .h-formBorder .el-form-item__content {
        vertical-align: top;
    }

    /* .width .el-form--inline .el-form-item{
        margin-right: 0;
    } */
    /* .width .h-formBorder .el-form-item__content{
        width:20%;
    } */
</style>
